<template>
  <el-form
    ref="form"
    v-loading="loading"
    class="search-form"
    element-loading-background="rgba(238, 238, 238, 0.8)"
    :element-loading-text="$t('messages.cargando')"
    label-position="top"
    :model="input"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <div v-if="step === 'search'">
      <!--
      <h2>{{ $t("messages.ingresa-tu-numero") }}</h2>
      -->
      <template v-if="response">
        <div
          v-if="response.error"
          class="alert retro-response-alert"
          role="alert"
          :class="'alert-' + (response.status ? response.status : 'danger')"
        >
          <div class="media">
            <img
              :src="
                'images/icon-' +
                (response.status ? response.status : 'danger') +
                '.svg'
              "
              alt="ícono mensaje"
              class="mr-4"
            />
            <div class="media-body">
              <p>{{ response.error.message }}</p>
              <ul v-if="response.coupons" class="response-list">
                <li
                  v-for="(r, i) in response.coupons.filter((d) => !d.success)"
                  :key="i"
                >
                  {{ couponSummary(r.coupon) }}:
                  <strong v-html="r.error.message"></strong>
                </li>
              </ul>
              <ul v-if="response.validation" class="response-list">
                <li v-for="(r, i) in response.validation" :key="i">
                  <strong v-html="r.message"></strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
      <div class="row">
        <div :class="boxColClass">
          <div class="card form-card">
            <div class="form-group">
              <label for="ticketNumber">{{
                $t("messages.numero-de-ticket")
              }}</label>
              <div class="row">
                <div class="col-12">
                  <input
                    id="ticketNumber"
                    v-model="input.ticketNumber"
                    v-mask="'###-##########'"
                    type="text"
                    class="form-control"
                    :placeholder="'Ej: 045-1234567890'"
                    required
                    aria-required="true"
                  />
                  <div class="help-block text-right">
                    <a
                      href="#"
                      aria-label="¿Donde encuentro mi número de ticket?"
                      @click="dialogVisible = true"
                      >{{ $t("messages.donde-lo-encuentro") }}</a
                    >
                  </div>
                </div>
                <div class="col-12 mt-4">
                  <button class="btn btn-block btn-danger">
                    {{ $t("messages.solicitar") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="retroWarningEnabled && showRetroWarning"
          :class="boxColClass"
        >
          <div class="alert alert-warning" role="alert">
            <div class="media">
              <img src="images/icon-warning.svg" alt="warning" class="mr-3" />
              <div class="media-body">
                {{ $t("messages.cambios-reflejados-en-24-horas") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="step === 'validation'">
      <h2>{{ $t("messages.verificacion-de-identidad") }}</h2>
      <p>{{ $t("messages.para-solicitar-tus-millas") }}</p>
      <div class="row">
        <div class="col-sm-6 offset-sm-3">
          <div class="card">
            <el-form-item
              :label="$t('messages.pais-de-emision')"
              prop="validation.country"
            >
              <el-select v-model="input.validation.country" filterable>
                <el-option
                  v-for="c in countries"
                  :key="c.code"
                  :value="c.code"
                  :label="c.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('messages.tipo-de-documento')"
              prop="validation.type"
            >
              <el-select v-model="input.validation.type">
                <el-option
                  value="identity"
                  :label="$t('messages.cedula')"
                ></el-option>
                <el-option
                  value="driver"
                  :label="$t('messages.licencia')"
                ></el-option>
                <el-option
                  value="passport"
                  :label="$t('messages.pasaporte')"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('messages.adjuntar-imagen')"
              prop="validation.image"
            >
              <el-upload action :http-request="httpRequest">
                <el-button size="small" type="primary">Subir imagen</el-button>
              </el-upload>
            </el-form-item>

            <button class="btn btn-block btn-danger">
              {{ $t("messages.verificar-identidad") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('messages.donde-encuentro-mi-numero')"
      :visible.sync="dialogVisible"
    >
      <p>{{ $t("messages.puedes-encontrarlo-en") }}</p>
      <p class="text-center">
        <img src="../../images/ticket.png" alt />
      </p>
      <span slot="footer" class="dialog-footer">
        <button
          class="btn btn-primary"
          type="button"
          @click="dialogVisible = false"
        >
          Cerrar
        </button>
      </span>
    </el-dialog>
  </el-form>
</template>
<script>
import { mask } from "vue-the-mask";
import axios from "axios";
import moment from "moment";
import serverBus from "../Bus/ServerBus";
import countries from "../../data/countries.json";
import ThreatMetrix from "../Libraries/ThreatMetrix";

export default {
  directives: {
    mask,
  },
  props: {
    csrf: { default: "", type: String },
    callcenter: { default: false, type: Boolean },
    latamId: { default: null, type: String },
    boxColClass: { default: "col-lg-6", type: String },
    retroWarningEnabled: { default: true, type: Boolean },
  },
  data() {
    return {
      input: {
        ticketNumber: "",
        validation: {
          country: "",
          image: "",
          type: "",
        },
      },
      ticketInfo: null,
      countries,
      loading: false,
      dialogVisible: false,
      step: "search",
      response: null,
      showRetroWarning: false,
    };
  },
  computed: {
    rules() {
      return {
        "validation.country": [
          {
            required: true,
            message: "Este campo es requerido",
          },
        ],
        "validation.type": [
          {
            required: true,
            message: "Este campo es requerido",
          },
        ],
        "validation.image": [
          {
            required: true,
            message: "Este campo es requerido",
          },
        ],
      };
    },
  },
  methods: {
    moment,
    couponSummary(coupon) {
      return `${coupon.Segment.departureAirport} - ${coupon.Segment.arrivalAirport} (${coupon.Segment.marketingAirlineCode} ${coupon.Segment.FlightDesignator.flightNumber})`;
    },
    httpRequest(a) {
      const reader = new FileReader();
      reader.readAsDataURL(a.file);
      reader.onload = () => {
        this.input.validation.image = reader.result;
      };
    },
    submit() {
      let validation = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          validation = true;
        }
      });

      if (validation) {
        this.loading = true;
        axios
          .post(
            this.callcenter ? "api/v1/callcenter/retros" : "api/v1/retros",
            {
              ticketNumber: this.input.ticketNumber.replace("-", ""),
              validation: this.input.validation,
              latamId: this.latamId,
            }
          )
          .then((response) => {
            ThreatMetrix.profile();
            this.loading = false;
            this.step = "search";
            this.input.ticketNumber = "";
            this.input.validation = null;
            this.showRetroWarning = true;
            this.response = response.data;
            serverBus.$emit("refreshStatus");
            this.$ga?.event?.({
              eventCategory: "retros",
              eventAction: "success",
            });
          })
          .catch((err) => {
            console.group(`[SearchForm] catch — ticket: ${this.input.ticketNumber}`);
            // console.log('[SearchForm] http status:', err.response?.status);
            // console.log('[SearchForm] raw error:', err);

            ThreatMetrix.profile();
            // console.log('[SearchForm] ThreatMetrix.profile() triggered (session reset)');

            this.loading = false;

            const data = err.response && err.response.data;
            // console.log('[SearchForm] response data:', data);

            if (!data) {
              console.warn('[SearchForm] no response data — network error or server unreachable');
              this.step = "search";
              this.response = { error: { message: "Error de red. Por favor intenta más tarde." } };
              console.groupEnd();
              return;
            }

            if (data.code === -2) {
              // console.log('[SearchForm] code -2: ticket not found — redirecting to OLA flow');
              window.location.href = this.callcenter
                ? `callcenter/${this.latamId}/ola?ticket-number=${this.input.ticketNumber}`
                : `ola?ticket-number=${this.input.ticketNumber}`;
              console.groupEnd();
              return;
            }

            if (data.code === -3) {
              // console.log('[SearchForm] code -3: ML flagged — requesting identity validation docs');
              this.step = "validation";
              this.$ga?.event?.({ eventCategory: "retros", eventAction: "requires-validation" });
              console.groupEnd();
              return;
            }

            // console.log(`[SearchForm] retro rejected — status: ${data.status}, message: ${data.error?.message}`);
            this.step = "search";
            this.response = data;
            this.showRetroWarning = data.status !== "danger";
            serverBus.$emit("refreshStatus");

            this.$ga?.event?.({
              eventCategory: "retros",
              eventAction: "reject",
              eventLabel: data.error && data.error.message,
            });
            (data.coupons || []).forEach((c) => {
              // console.log(`[SearchForm] coupon ${c.coupon?.Segment?.departureAirport}-${c.coupon?.Segment?.arrivalAirport}: ${c.success ? 'success' : 'rejected — ' + c.error?.message}`);
              this.$ga?.event?.({
                eventCategory: "segment",
                eventAction: c.success ? "success" : "reject",
                eventLabel: c.success ? undefined : c.error && c.error.message,
              });
            });
            console.groupEnd();
          });
      }
    },
  },
};
</script>
